import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Context as ResponsiveContext } from "react-responsive";
import { BrowserRouter } from "react-router";
import { ThemeProvider } from "styled-components";
import { AppRouter } from "@core/routing/appRouter";
import { Services, ServicesContext } from "@core/servicesContext";
import { ErrorFallback } from "@ui/components/errorFallback";
import { theme } from "@ui/styles/theme";
import { DEFAULT_WIDTH } from "@ui/styles/utils";
import { useIsMounted } from "@utils/hooks";

interface ServerAppProps {
	services: Services;
}
export const App: React.FC<ServerAppProps> = ({ services }) => {
	const mounted = useIsMounted();

	return (
		<ServicesContext.Provider value={services}>
			<ThemeProvider theme={theme}>
				<BrowserRouter>
					{/* Same width on server and first client paint. After mount, undefined lets queries follow the real viewport — an empty object is still a static device, so max-width never matches. */}
					<ResponsiveContext.Provider value={mounted ? undefined : { width: DEFAULT_WIDTH }}>
						<ErrorBoundary FallbackComponent={ErrorFallback}>
							<AppRouter />
						</ErrorBoundary>
					</ResponsiveContext.Provider>
				</BrowserRouter>
			</ThemeProvider>
		</ServicesContext.Provider>
	);
};
